import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContentForLeafCollectionDetailsReport
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LeafCollectionDetailsReportSchemaObject } from "../leafCollectionDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import moment from 'moment';
import '../Pages/tableFooter.css';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';

const screenCode = "LEAFCOLLECTIONDETAILSREPORT";

export function LeafCollectionDetailsReport(props) {
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: "",
        qunatity: "100"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: "",
        qunatity: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(LeafCollectionDetailsReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["fieldCardNumber","FieldCollectionPointCode", "filedRegistrationNumber","narration", "filedDate",
        "collectionTypeName", "filedTagNumber", "fieldGrossAmount_Kg",
        "fieldNetAmount_Kg", "factoryGrossAmount_Kg", "factoryNetAmount_Kg", "glx"];

    const [contentRowNames, setContentRowNames] = useState([]);
    const [fieldColumnNames, setFieldColumnNames] = useState([]);
    const [factoryColumnNames, setFactoryColumnNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Card Number", value: "fieldCardNumber" },
        { label: "Route Code", value: "FieldCollectionPointCode" },
        { label: "Reg Number", value: "filedRegistrationNumber" },
        { label: "Narration", value: "narration" },
        { label: "Date", value: "filedDate" },
        { label: "Leaf Type", value: "collectionTypeName" },
        { label: "Tag Number", value: "filedTagNumber" },
        { label: "Field Gross /Kg", value: "fieldGrossAmount_Kg" },
        { label: "Field Net /Kg", value: "fieldNetAmount_Kg" },
        { label: "Factory Gross /Kg", value: "factoryGrossAmount_Kg" },
        { label: "Factory Net /Kg", value: "factoryNetAmount_Kg" },
        { label: "G/L/X", value: "glx" }
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [lossExces, setLossExces] = useState(0);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0",
        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0",
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
        setIsTableHide(true);
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
        setIsTableHide(true);
    }

    function handleQuantityChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            qunatity: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafCollectionDetailsReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLEAFCOLLECTIONDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getLeafCollectionDetailsReportData(leafCollectionDetails);

        var contentResult = generateTableInitializationData(result);

        var fieldData = mergeFieldData(result.fieldData);
        var factoryData = mergeFactoryData(result.factoryData);

        var finalResult = mergeFactoryAndFieldData(fieldData, factoryData);

        var totalRowResult = calculateTotal(finalResult);

        if (finalResult.length > 0) {
            setIsTableHide(false);
            setReportData(finalResult);
            createDataTable(contentResult, ["#leafCollectionSummary", "#leafCollectionSummaryPdf"]);

            generateCsvData(finalResult, totalRowResult, contentResult);
        }
    }

    function calculateTotal(data) {
        var total = [];
        var bagCount = 0;

        data.forEach(x => {
            bagCount++;
            for (var property in x) {
                if (property.includes("_Kg") || property === "glx") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        res.bagCount = bagCount;

        var fiNet = res.find(x => x.name === "fieldNetAmount_Kg");
        var faNet = res.find(x => x.name === "factoryNetAmount_Kg");

        var lossExces = (faNet === undefined ? 0 : faNet.value) - (fiNet === undefined ? 0 : fiNet.value);
    

        setLossExces(lossExces);
        setFullTotalRow(res);
        return res;
    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { fieldCardNumber: "Total" }

        newRecord.filedTagNumber = totalRowResult.bagCount;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? parseFloat(0.00) : parseFloat(x.value.toFixed(2));
        });

        copyOfData.push(newRecord, {}, {}, {
            fieldCardNumber: "Current Date: " + new Date().toLocaleString(),
            filedRegistrationNumber: "User: " + tokenService.getUserNameFromToken(),
        });
        setCsvData(copyOfData);
    }

    function generateTableInitializationData(data) {

        var copyOfInitialContentRownames = initialContentRownames;
        var copyOfInitialCsvHeaders = initialCsvHeaders;

        var fieldDeductionNames = [];
        var fieldDeductionIds = [];
        var factoryDeductionNames = [];
        var factoryDeductionIds = [];

        var csvFieldsData = [];
        var csvFactoryData = [];

        data.fieldData.forEach(x => {
            if ((x.fieldDeductionTypeName !== null && x.fieldDeductionTypeName !== undefined) && x.filedDeductionTempId !== 0) {
                fieldDeductionNames.push(x.fieldDeductionTypeName.split(' ').map(x => x[0]).join(''));
                fieldDeductionIds.push((x.filedDeductionTempId + "_Kg_Fi"));
                csvFieldsData.push({ label: ("Field " + x.fieldDeductionTypeName), value: (x.filedDeductionTempId + "_Kg_Fi") })
            }
        });

        data.factoryData.forEach(x => {
            if ((x.factoryDeductionTypeName !== null && x.factoryDeductionTypeName !== undefined) && x.factoryDeductionTempId !== 0) {
                factoryDeductionNames.push(x.factoryDeductionTypeName.split(' ').map(x => x[0]).join(''));
                factoryDeductionIds.push((x.factoryDeductionTempId + "_Kg_Fa"));
                csvFactoryData.push({ label: ("Factory " + x.factoryDeductionTypeName), value: (x.factoryDeductionTempId + "_Kg_Fa") })
            }
        });

        fieldDeductionNames = [...new Set(fieldDeductionNames)];
        fieldDeductionIds = [...new Set(fieldDeductionIds)];
        factoryDeductionNames = [...new Set(factoryDeductionNames)];
        factoryDeductionIds = [...new Set(factoryDeductionIds)];

        csvFactoryData = csvFactoryData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);
        csvFieldsData = csvFieldsData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);

        copyOfInitialContentRownames.splice(8, 0, ...fieldDeductionIds);
        copyOfInitialContentRownames.splice((10 + fieldDeductionIds.length), 0, ...factoryDeductionIds);

        copyOfInitialCsvHeaders.splice(8, 0, ...csvFieldsData);
        copyOfInitialCsvHeaders.splice((10 + fieldDeductionIds.length), 0, ...csvFactoryData);

        setCsvHeaders(copyOfInitialCsvHeaders);

        setContentRowNames(copyOfInitialContentRownames);
        setFieldColumnNames(fieldDeductionNames);
        setFactoryColumnNames(factoryDeductionNames);

        return {
            contentRowNames: copyOfInitialContentRownames,
            fieldDeductionNames: fieldDeductionNames,
            factoryDeductionNames: factoryDeductionNames,
            fieldDeductionIds: fieldDeductionIds,
            csvHeadersData: copyOfInitialCsvHeaders
        }
    }

    function mergeFactoryAndFieldData(fieldData, factoryData) {
        var mergedResult = [];

        fieldData.forEach(x => {

            var matchedResult = factoryData.find(y => y.factoryTagNumber === x.filedTagNumber && x.filedDate === y.factoryDate);

            if (matchedResult) {
                mergedResult.push({ ...x, ...matchedResult });
            }
        });

        factoryData.forEach(x => {

            var result = mergedResult.find(y => x.factoryTagNumber === y.factoryTagNumber && y.factoryDate === x.factoryDate);

            if (!result) {
                x.fieldCardNumber = x.factoryCardNumber;
                x.filedRegistrationNumber = x.factoryRegistrationNumber;
                x.filedDate = x.factoryDate;
                x.filedTime = x.factoryTime;
                x.collectionTypeName = '';
                x.filedTagNumber = x.factoryTagNumber;
                x.collectionPointID = '';
                x.narration = '';
                mergedResult.push(x);
            }
        })

        mergedResult.forEach(x => {
            x.filedTime = moment(x.filedTime, "H:mm:ss").format('LT');
            x.glx = (x.factoryGrossAmount_Kg === undefined ? 0 : parseFloat(x.factoryGrossAmount_Kg))
                - (x.fieldGrossAmount_Kg === undefined ? 0 : parseFloat(x.fieldGrossAmount_Kg));
            
            
        });
            var finalResult = [];
                if(leafCollectionDetails.qunatity == 0 || leafCollectionDetails.qunatity == undefined){
                    finalResult = mergedResult;
                }else 
                
                {
                    var variance = (leafCollectionDetails.qunatity / 1000)
                    finalResult =  _.filter(mergedResult, function(o) { return ((o.factoryActualAmount_Kg < o.fieldActualAmount_Kg ) && (o.fieldActualAmount_Kg <= o.factoryActualAmount_Kg + variance)); });
                }

        return finalResult;
    }

    function mergeFactoryData(data) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultFactoryValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.factoryWeighDetailID === x.factoryWeighDetailID
                    && a.factoryDate === x.weightReadTime.split("T")[0]);

                if (duplicateRecord) {
                    duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"] = (duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"] === undefined ? 0
                        : parseFloat(duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"])) + parseFloat(x.factoryDeductionAmount);
                } else {
                    mergedResult.push(setDefaultFactoryValues(x));
                }

            }
        });

        return mergedResult;
    }

    function mergeFieldData(data) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultFieldValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.productCollectionDetailsID === x.productCollectionDetailsID
                    && a.filedDate === x.weightReadTime.split("T")[0]);

                if (duplicateRecord) {
                    duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] = (duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] === undefined ? 0
                        : parseFloat(duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"])) + parseFloat(x.fieldDeductionAmount);
                } else {
                    mergedResult.push(setDefaultFieldValues(x));
                }

            }
        });

        return mergedResult;
    }

    function setDefaultFieldValues(record) {
        var newRecord = {
            type: 1,
            fieldCardNumber: record.fieldCardNumber,
            fieldCollectionPointCode: record.fieldCollectionPointCode,
            fieldCollectionPointID: record.fieldCollectionPointID,
            fieldCollectionPointName: record.fieldCollectionPointName,
            FieldCollectionPointCode: record.fieldCollectionPointCode,
            fieldGrossAmount_Kg: record.fieldGrossAmount,
            fieldNetAmount_Kg: record.fieldNetAmount,
            fieldActualAmount_Kg: record.fieldActualAmount,
            collectionTypeName: record.collectionTypeName,
            filedRegistrationNumber: record.filedRegistrationNumber,
            filedTagNumber: record.filedTagNumber,
            productCollectionDetailsID: record.productCollectionDetailsID,
            productCollectionID: record.productCollectionID,
            filedDate: record.weightReadTime.split("T")[0],
            filedTime: record.weightReadTime.split("T")[1],
            collectionPointID: record.collectionPointID,
            narration: record.narration

        };

        if (record.filedDeductionTempId !== null && record.fieldDeductionAmount !== null) {
            newRecord[record.filedDeductionTempId + "_Kg_Fi"] = record.fieldDeductionAmount;
        }

        return newRecord;
    }

    function setDefaultFactoryValues(record) {
        var newRecord = {
            type: 2,
            factoryCollectionPointID: record.factoryCollectionPointID,
            factoryCollectionPointName: record.factoryCollectionPointName,
            factoryGrossAmount_Kg: record.factoryGrossAmount,
            factoryNetAmount_Kg: record.factoryNetAmount,
            factoryActualAmount_Kg: record.factoryActualAmount,
            factoryTagNumber: record.factoryTagNumber,
            factoryWeighDetailID: record.factoryWeighDetailID,
            factoryDate: record.weightReadTime.split("T")[0],
            factoryTime: record.weightReadTime.split("T")[1],
            factoryCardNumber: record.factoryCardNumber,
            factoryRegistrationNumber: record.factoryRegistrationNumber
        };

        if (record.factoryDeductionTempId !== null && record.factoryDeductionAmount !== null) {
            newRecord[record.factoryDeductionTempId + "_Kg_Fa"] = record.factoryDeductionAmount;
        }

        return newRecord;
    }

    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#leafCollectionSummaryPdf' ? true : false,
                searching: x === '#leafCollectionSummaryPdf' ? false : true,
                paging: x === '#leafCollectionSummaryPdf' ? false : true,
                scrollX: false
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'LeafCollectionDetailsReport',
            fileName: 'Leaf Collection Details Report',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            fromDate: "",
            toDate: "",
            qunatity: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
            qunatity: searchForm.qunatity
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12" style={{ width: 1 }}>
                    <div className="card">

                        <PageHeader
                            title="Leaf Collection Details Report - 900g"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="qunatity">Variance /g *</InputLabel>
                                        <Select fullWidth
                                            id="qunatity"
                                            name="qunatity"
                                            value={leafCollectionDetails.qunatity}
                                            onChange={(e) => handleQuantityChange(e.target)}>
                                            <MenuItem value={100}>100</MenuItem>
                                            <MenuItem value={200}>200</MenuItem>                                         
                                        </Select>
                                        {errors["qunatity"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["qunatity"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="pl-3 pb-2">
                                            <h5>Loss/Excess (Kg): <span class={lossExces > 0 ? "badge badge-success" : "badge badge-danger"}>
                                                {lossExces.toFixed(2)}
                                            </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <table id="leafCollectionSummary"
                                                    style={{
                                                        display: "block", overflowX: "auto",
                                                        whiteSpace: "nowrap", borderColor: "white"
                                                    }}>
                                                    <thead>
                                                        <tr>
                                                            <th rowSpan="2">CardNo</th>
                                                            <th rowSpan="2">Route Code</th>
                                                            <th rowSpan="2">RegNo</th>
                                                            <th rowSpan="2">Narration</th>
                                                            <th rowSpan="2">Date</th>
                                                            <th rowSpan="2">LT</th>
                                                            <th rowSpan="2">TagNo</th>
                                                            <th style={{ textAlign: "center" }} colSpan={2 + fieldColumnNames.length}>Field</th>
                                                            <th style={{ textAlign: "center" }} colSpan={2 + factoryColumnNames.length}>Factory</th>
                                                            <th rowSpan="2">Variance +/-</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Gross /Kg</th>
                                                            {fieldColumnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x}</th>
                                                                )
                                                            })}
                                                            <th>Net /Kg</th>
                                                            <th>Gross /Kg</th>
                                                            {factoryColumnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x}</th>
                                                                )
                                                            })}
                                                            <th>Net /Kg</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForLeafCollectionDetailsReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="6">Total</th>
                                                            <th style={{ textAlign: "right" }}>{fullTotalRow.bagCount}</th>
                                                            {contentRowNames.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x);

                                                                if (res) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                } else if (res === undefined && x.includes("_Kg")) {
                                                                    return (
                                                                        <th index={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                                    );
                                                                }

                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Leaf Collection Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fieldColumnNames={fieldColumnNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} lossExces={lossExces}
                                            factoryColumnNames={factoryColumnNames} fullTotalRow={fullTotalRow} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
}
